<template>
    <template v-if="item.is_image">
        <img
            :src="item.preview_url ?? item.thumbnail_url ?? item.url"
            :alt="item.name"
            class="relative z-10 object-contain w-full h-full media-picker__thumb"
        />
    </template>
    <template v-else>
        <div class="relative z-10 flex items-center justify-center w-full h-full py-10 text-center group media-picker__thumb">
            <div>
                <icon
                    v-if="item.icon"
                    :icon="item.icon"
                    class="size-12"
                    :class="[`text-${item.icon_color}-400`]"
                ></icon>
                <icon v-else class="size-12" icon="hero/outline/paper-clip"></icon>
                <div class="absolute max-w-full overflow-hidden text-xs truncate inset-x-4">
                    {{ item.name }}
                </div>
            </div>
        </div>
    </template>
</template>

<script setup lang="ts">
import { toRef } from 'vue';

interface Props {
    media?: {
        is_image: boolean;
        name: string;
        icon: string;
        icon_color: string;
        url: string;
        thumbnail_url: string | null;
    };
}

const props = withDefaults(defineProps<Props>(), {
    media: () => ({
        is_image: false,
        name: '',
        icon: '',
        icon_color: 'gray',
        url: '',
        thumbnail_url: null,
    }),
});

const item = toRef(props, 'media');
</script>
